// --- React ---
import { useEffect, useState } from "react";

// --- Components ---
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

// --- Models ---
import { stationCameraSchema } from '../../../models/schema/stationCamera';

// --- Utils ---
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { notify } from "../../../common/notificationService";
import { omitMetaFields } from "../../../utils/helper";

// --- Services ---
import stationCameraSvc from '../../../services/api/stationCamera';
import FormInput from "../../form-input/FormInput";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    data: any | null;
    stationId: string | number;
    onSuccess?: () => Promise<void>;
}

const StationCameraModal = ({
    isOpen,
    onClose,
    data,
    stationId,
    onSuccess,
}: Props) => {
    const isCreate = !data?.id;
    const [loading, setLoading] = useState(false);
    const schema = stationCameraSchema;

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        control,
        watch,
        formState: { errors, isDirty }
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            stationId: Number(stationId),
        },
    });

    useEffect(() => {
        if (data) {
            reset(omitMetaFields(data));
        }
    }, [data]);

    const onSubmit = async (values: any) => {
        console.log('values', values);
        setLoading(true);
        try {
            const res = isCreate ? await stationCameraSvc.createStationCamera({ ...values, stationId: Number(stationId) }) : await stationCameraSvc.updateStationCamera({ ...values, id: Number(data?.id) });
            if (res && res.content.status) {
                onClose();
                onSuccess?.();
                notify("Thành công", isCreate ? "Thêm thành công" : "Cập nhật thành công", "success");
                setLoading(false);
            }
        } catch (e: any) {
            notify("Lỗi", "Xảy ra lỗi", "danger");
        } finally {
            setLoading(false);
        }
    };


    return (
        <Dialog open={isOpen} onClose={onClose}>
            <DialogTitle>
                {isCreate ? "Thêm camera" : "Cập nhật camera " + data?.name}
                <hr className="my-2" />
            </DialogTitle>
            <DialogContent>
                <Typography>
                    <div className="min-w-[400px] py-1">
                        <div className="flex flex-col gap-4">
                            <FormInput
                                label="Tiêu đề"
                                name="title"
                                register={register("title")}
                                error={errors.title}
                                required
                            />
                            <FormInput
                                label="Nguồn"
                                name="source"
                                register={register("source")}
                                error={errors.source}
                                required
                            />
                            <FormInput
                                label="Tên camera"
                                name="name"
                                register={register("name")}
                                error={errors.name}
                                required
                            />
                        </div>
                    </div>
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit" variant="contained">
                    Hủy
                </Button>
                <Button onClick={handleSubmit(onSubmit)} color="primary" variant="contained">
                    {isCreate ? "Thêm" : "Cập nhật"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default StationCameraModal;